<script>
  import options from './OnlineDonationQRPrintPageContent.options'
  export default options
</script>

<template>
  <article class="kb-online-donation-qr-print-page-content">

    <div class="kb-online-donation-qr-print-page-content__wrapper">

      <header class="kb-online-donation-qr-print-page-content__header">    
        <div class="kb-online-donation-qr-print-page-content__logo" v-html="svgLogo"></div>
      </header>

      <div class="kb-online-donation-qr-print-page-content__container">

        <h1 class="kb-online-donation-qr-print-page-content__title"> {{ getLabel("title") + ' ' + title}} </h1>

        <div class="kb-online-donation-qr-print-page-content__QR-box-wrapper">

          <div class="kb-online-donation-qr-print-page-content__QR-box">

            <div class="kb-online-donation-qr-print-page-content__QR-img">
              <img :src="`data:image/png;base64, ${qrImgUrlBase}`" :alt='getLabel("qrCodeImgAlt")' />
            </div>

            <div class="kb-online-donation-qr-print-page-content__QR-details" v-html="getLabel('qrCodeText')">

            </div>

          </div>   

        </div>   
        
        <p class="kb-online-donation-qr-print-page-content__thanks-text">{{getLabel("thanksText")}}</p>

      </div>
  

    </div>

  </article>
</template>
